import React from "react";
import {Link} from "react-router-dom";

export const NotFoundScreen = () => {


    return <div className="not-found-container container">
        <h1 className="my-4 color-green">Page introuvable</h1>
        <div className="text-center">
            <img className="logo-bi"
                 src={process.env.PUBLIC_URL + '/img/logo.svg'} width={"200 px"}
                 alt="Bouygues Immobilier"/>
            <img src="/img/travolta.gif" className="not-found-gif" alt="John Travolta"/>
            <Link to={'/'} className="btn btn-link btn-lg mt-3">Emmène moi à l'accueil</Link>
        </div>
    </div>
};